import { render, staticRenderFns } from "./AbsenceManagementTable.vue?vue&type=template&id=3964d26d&"
import script from "./AbsenceManagementTable.vue?vue&type=script&lang=js&"
export * from "./AbsenceManagementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports